export default __webpack_public_path__ + "static/media/cold-blue-majik.4a062dec.png";